import i18n from '@/core/i18n';

import { ProjectChangedFieldNameDTO } from '../../types/dto/project-changed-field.dto';

/**
 * Maps field name DTO to localized field name
 */
export const getLocalizedFieldName = (fieldName: ProjectChangedFieldNameDTO): string => {
  const fieldNameMap: Record<ProjectChangedFieldNameDTO, string> = {
    [ProjectChangedFieldNameDTO.STATUS]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.status'
    ),
    [ProjectChangedFieldNameDTO.TENTATIVE_PROBABILITY]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.tentativeProbability'
    ),
    [ProjectChangedFieldNameDTO.MANAGER_USER]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.manager'
    ),
    [ProjectChangedFieldNameDTO.PROJECT_START_DATE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.projectStartDate'
    ),
    [ProjectChangedFieldNameDTO.PROJECT_END_DATE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.projectEndDate'
    ),
    [ProjectChangedFieldNameDTO.INDUSTRIES]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.industries'
    ),
    [ProjectChangedFieldNameDTO.CUSTOM_ATTRIBUTES]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.customAttributes'
    ),
    [ProjectChangedFieldNameDTO.BILLING_MODEL]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.billingModel'
    ),
    [ProjectChangedFieldNameDTO.DEFAULT_CURRENCY_CODE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.defaultCurrency'
    ),
    [ProjectChangedFieldNameDTO.BUDGET]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.budget'
    ),
    [ProjectChangedFieldNameDTO.RATE_SOURCE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.rateSource'
    ),
    [ProjectChangedFieldNameDTO.FLAT_RATE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.flatRate'
    ),
    [ProjectChangedFieldNameDTO.USER_RATES]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.userRates'
    ),
    [ProjectChangedFieldNameDTO.USER_CUSTOM_RATE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.userCustomRate'
    ),
    [ProjectChangedFieldNameDTO.USER_RATE_SOURCE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.userRateSource'
    ),
    [ProjectChangedFieldNameDTO.RATE_CARD]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.rateCard'
    ),
    [ProjectChangedFieldNameDTO.GOOGLE]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.google'
    ),
    [ProjectChangedFieldNameDTO.JIRA]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.jira'
    ),
    [ProjectChangedFieldNameDTO.QUICK_BOOKS]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.quickBooks'
    ),
    [ProjectChangedFieldNameDTO.UNKNOWN]: i18n.t(
      'authenticated.projects:details.tabs.changes.fieldNames.unknown'
    ),
  };

  return fieldNameMap[fieldName] || fieldName;
};
